export default "__VITE_ASSET__ac461af5__"